import {AppJSThemeOptions} from '@app/theme';
import {JS_THEME_DARK_VARIABLES} from './js-theme-base';

export const DARK_THEME = {
	name: 'dark',
	base: 'dark',
	variables: {
		...JS_THEME_DARK_VARIABLES,
		layoutBg: JS_THEME_DARK_VARIABLES.bg,
	},
} as AppJSThemeOptions;
